import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { telemetry } from "globals/endpoints";
import { Box, Button, CircularProgress } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import MDButton from "components/MDButton";

export default function PlayerWithAuth({ playerUrl, playFileType }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [fileName, setFileName] = useState("");

  useEffect(() => {
    let objectUrl;

    const loadFile = async () => {
      try {
        const res = await telemetry.get(playerUrl, {
          responseType: "blob",
        });
        const blob = res.data;

        // file name nikalne ki koshish karo
        const contentDisposition = res.headers["content-disposition"];
        let name = "file";
        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?(.+)"?/);
          if (match) name = match[1];
        } else {
          // agar url se hi nikalna ho
          name = playerUrl.split("/").pop();
        }
        setFileName(name);

        objectUrl = URL.createObjectURL(blob);
        setBlobUrl(objectUrl);
      } catch (err) {
        console.error("Failed to load media:", err);
      }
    };

    loadFile();
    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [playerUrl]);

  if (!blobUrl)
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center", 
          justifyContent: "center", 
          gap: 1, 
          p: 2,
        }}
      >
        <CircularProgress size={24} />
        Loading...
      </Box>
    );

  return (
    <Box>
      {playFileType === "image" ? (
        <Box sx={{ width: "100%", textAlign: "center" }}>
          <img
            src={blobUrl}
            alt={fileName}
            style={{ maxWidth: "100%", maxHeight: 400 }}
          />
        </Box>
      ) : (
        <ReactPlayer
          url={blobUrl}
          controls
          playing
          width="100%"
          height={playFileType === "audio" ? "50px" : "400px"}
        />
      )}

      {/* Download button */}
      <Box sx={{ mt: 1, textAlign: "right" }}>
        <MDButton
          variant="outlined"
          startIcon={<DownloadIcon />}
          component="a"
          href={blobUrl}
          download={fileName}
        >
          Download
        </MDButton>
      </Box>
    </Box>
  );
}
